import * as React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import Button from '@mui/material/Button';
import MenuContent from './MenuContent';

function SideMenuMobile({ open, toggleDrawer }) {
  const nombre = localStorage.getItem('nombre') || '';
  const usuario = localStorage.getItem('usuario') || '';
  const initials = nombre
    .split(' ')
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: '#0f172a',
          width: '75dvw',
          maxWidth: 280,
        },
      }}
    >
      <Stack sx={{ height: '100%' }}>
        {/* User header */}
        <Stack direction="row" sx={{ p: 2, pb: 1.5, gap: 1.5, alignItems: 'center' }}>
          <Avatar
            sx={{
              width: 34,
              height: 34,
              bgcolor: 'hsl(210,98%,42%)',
              fontSize: '0.78rem',
              fontWeight: 700,
              flexShrink: 0,
            }}
          >
            {initials || nombre.charAt(0).toUpperCase()}
          </Avatar>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="body2"
              noWrap
              sx={{ fontWeight: 600, color: 'rgba(255,255,255,0.9)', fontSize: '0.82rem' }}
            >
              {nombre}
            </Typography>
            <Typography
              variant="caption"
              noWrap
              sx={{ color: 'rgba(255,255,255,0.38)', fontSize: '0.7rem' }}
            >
              {usuario}
            </Typography>
          </Box>
        </Stack>
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.07)', mx: 2 }} />

        {/* Nav */}
        <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
          <MenuContent />
        </Box>

        {/* Logout */}
        <Box sx={{ p: 2 }}>
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.07)', mb: 2 }} />
          <Button
            variant="outlined"
            fullWidth
            startIcon={<LogoutRoundedIcon />}
            sx={{
              color: 'rgba(255,255,255,0.6)',
              borderColor: 'rgba(255,255,255,0.12)',
              '&:hover': {
                borderColor: 'rgba(255,255,255,0.25)',
                bgcolor: 'rgba(255,255,255,0.05)',
              },
            }}
          >
            Cerrar sesión
          </Button>
        </Box>
      </Stack>
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};

export default SideMenuMobile;
